import {BaseLS} from './BaseLS';
import {IEnum} from '../../../@types/enum';

const STORAGE_KEY = 'audioCodec';

export class AudioCodec extends BaseLS<IEnum> {
  constructor() {
    super(STORAGE_KEY);
  }
}
